<template>
    <div class="auth-wrapper auth-v2 bg-white">
        
        <b-row class="auth-inner m-0">
            <div class="w-100 d-flex flex-column ">
                <HeaderBar/>
                <div class="mt-4  bg-white">
                    <v-offline 
                    online-class="online"
                    offline-class="offline"
                    @detected-condition="onConnectionChange">
                        <template v-if="online">
                        <div class="flex w-full h-full justify-center items-center text-6xl">
                            
                        </div>
                        </template>
                        <template v-if="!online">
                        <div class="flex w-full h-full justify-center items-center text-6xl">
                        Sin Conexión
                        </div>
                        </template>
                    </v-offline>
                    <!-- Basic Module -->
                    <div class="d-flex justify-content-center align-items-center mb-1 mt-3 ">
                        <div class="title">Módulo Básico</div>
                    </div>

                    <div class="d-flex flex-wrap justify-content-center">
                        <b-row class="ml-1 mr-1">
                            <b-col
                                cols="6"
                            >
                                <b-card class="text-center" @click="navigateTo('basic-farm')">
                                    <b-avatar
                                        class="mb-1"
                                        variant="primary"
                                        size="100"
                                    >
                                        <b-img width="60px" 
                                            src="@/assets/images/ganImage/icons/farm.png"
                                        />
                                    </b-avatar>
                                    <div class="truncate">
                                        <h3 class="mb-25 font-weight-bolder">
                                            Fincas
                                        </h3>
                                    </div>
                                </b-card>
                            </b-col>
                            <b-col
                                cols="6"
                            >
                                <b-card class="text-center" @click="navigateTo('basic-animals')">
                                    <b-avatar
                                        class="mb-1"
                                        variant="primary"
                                        size="100"
                                    >
                                        <b-img width="60px" 
                                            src="@/assets/images/ganImage/icons/animals.png"
                                        />
                                    </b-avatar>
                                    <div class="truncate">
                                        <h3 class="mb-25 font-weight-bolder">
                                            Animales
                                        </h3>
                                    </div>
                                </b-card>
                            </b-col>
                            <b-col
                                cols="6"
                            >
                                <b-card class="text-center" @click="navigateTo('basic-users')">
                                    <b-avatar
                                        class="mb-1"
                                        variant="primary"
                                        size="100"
                                    >
                                        <b-img width="60px" 
                                            src="@/assets/images/ganImage/icons/users.png"
                                        />
                                    </b-avatar>
                                    <div class="truncate">
                                        <h3 class="mb-25 font-weight-bolder">
                                            Usuarios
                                        </h3>
                                    </div>
                                </b-card>
                            </b-col>
                            <b-col
                                cols="6"
                            >
                                <b-card class="text-center" @click="navigateTo('basic-advice')">
                                    <b-avatar
                                        class="mb-1"
                                        variant="primary"
                                        size="100"
                                    >
                                        <b-img width="60px" 
                                            src="@/assets/images/ganImage/icons/advisory.png"
                                        />
                                    </b-avatar>
                                    <div class="truncate">
                                        <h3 class="mb-25 font-weight-bolder">
                                            Asesoría
                                        </h3>
                                    </div>
                                </b-card>
                            </b-col>
                            <b-col
                                cols="12"
                            >
                                <b-card class="text-center" @click="navigateTo('basic-dataloghome')">
                                    <b-avatar
                                        class="mb-1"
                                        variant="danger"
                                        size="100"
                                    >
                                        <b-img width="60px" 
                                            src="@/assets/images/ganImage/icons/add-data.png"
                                        />
                                    </b-avatar>
                                    <div class="truncate">
                                        <h3 class="mb-25 font-weight-bolder">
                                            Cargar Datos
                                        </h3>
                                    </div>
                                </b-card>
                            </b-col>
                        </b-row>
                    </div>
                    <div>
                        <div class="accordion" role="tablist">
                            <b-card no-body class="mb-1">
                            <b-card-header header-tag="header" class="p-1" role="tab">
                                <b-button block v-b-toggle.accordion-1 variant="primary">Animales</b-button>
                            </b-card-header>
                            <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                                <b-card-body>
                                    <b-card-text>
                                        <div v-if="!online" class="text-center">
                                            <b-img width="100px" 
                                            src="@/assets/images/ganImage/icons/offline.png"
                                            />
                                            <p><strong>Sin Conexión</strong></p>
                                        </div>
                                        <vue-good-table :columns="columns" :rows="rows" :rtl="direction"  styleClass="vgt-table bordered"
                                        :search-options="{
                                            enabled: true,
                                            externalQuery: searchTerm
                                        }" 
                                        
                                        :pagination-options="{
                                            enabled: true,
                                            perPage: pageLength
                                        }"
                                        
                                        :sort-options="{
                                            enabled: true,
                                        }"
                                        >
                                        <template slot="table-row" slot-scope="props">

                                            <!-- Column: Name -->
                                            <span v-if="props.column.field === 'sex'" class="text-center">
                                            <span v-if="props.row.sex===false" class="text-center">M</span>
                                            <span v-if="props.row.sex===true" class="text-center">H</span>
                                            
                                            </span>

                                            <!-- Column: Status -->
                                            <span v-else-if="props.column.field === 'status'">
                                            <b-badge :variant="statusVariant(props.row.status)">
                                                {{ props.row.status }}
                                            </b-badge>
                                            </span>

                                            <!-- Column: Common -->
                                            <span v-else>
                                            {{ props.formattedRow[props.column.field] }}
                                            </span>
                                        </template>

                                        <!-- pagination -->
                                        <template slot="pagination-bottom" slot-scope="props">
                                            <div class="d-flex justify-content-between flex-wrap">
                                            
                                            </div>
                                        </template>
                                        </vue-good-table>
                                    </b-card-text>
                                    <b-card-text>
                                    </b-card-text>
                                </b-card-body>
                            </b-collapse>
                            </b-card>

                            <b-card no-body class="mb-1">
                            <b-card-header header-tag="header" class="p-1" role="tab">
                                <b-button block v-b-toggle.accordion-2 variant="primary">Económicos</b-button>
                            </b-card-header>
                            <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                                <b-card-body>
                                    <b-card-text>
                                        <div v-if="!online" class="text-center">
                                            <b-img width="100px" 
                                            src="@/assets/images/ganImage/icons/offline.png"
                                            />
                                            <p><strong>Sin Conexión</strong></p>
                                        </div>
                                        <BarChart v-if="showPieChart"
                                            :width="330" 
                                            :data="EconomicChartData"
                                            :options="chartLineOptions"
                                        /> 
                                    </b-card-text>
                                </b-card-body>
                            </b-collapse>
                            </b-card>

                            <b-card no-body class="mb-1">
                            <b-card-header header-tag="header" class="p-1" role="tab">
                                <b-button block v-b-toggle.accordion-3 variant="primary">Otros</b-button>
                            </b-card-header>
                            <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
                                <b-card-body>
                                    <b-card-text>
                                    </b-card-text>
                                </b-card-body>
                            </b-collapse>
                            </b-card>
                        </div>
                    </div>
                    <b-form class="auth-login-form">
                        <!-- buttons -->
                        <div class="d-flex justify-content-center  mt-2 mb-5 ">
                            <b-button class="bg-primary buttonContent w-75" block @click="navigateTo('basic-report')" >
                                <b-link style="color:white"> Reportes</b-link>
                            </b-button>
                        </div>
                           
                    </b-form> 
                </div>
                <ControlMenu />
            </div>
        </b-row>

    </div>
</template>

<script>
import { BRow, BCol, BLink, BImg, BForm, VBToggle,BButton,BCollapse, BCard,BCardHeader,BCardBody, BCardText, BAvatar } from 'bootstrap-vue'
import ControlMenu from '../ControlMenu.vue'
import PlusButton from '../PlusButton.vue'
import HeaderBar from '../HeaderBar.vue'
import LineChart from '@/components/Basic/Charts/LineChart.vue'
import PieChart from '@/components/Basic/Charts/PieChart.vue'
import BarChart from '@/components/Basic/Charts/BarChart.vue'
import { VOffline } from 'v-offline';
import { VueGoodTable } from 'vue-good-table'
import store from '@/store/index'

export default {
    components: {
        BRow,
        PlusButton,
        BCol,
        BLink,
        BImg,
        BForm,
        VBToggle,
        BButton,
        BCollapse,
        BCard,
        BCardHeader,
        BCardBody, 
        BCardText,
        BAvatar,
        ControlMenu,
        HeaderBar,
        LineChart,
        PieChart,
        BarChart,
        VOffline,
        VueGoodTable,
    },
    data() {
        return {
            online:false,
            incomes:0,
            expenses:0,
            status: '',
            visible: true,
            showLineChart:false,
            showPieChart:false,
            pageLength: 25,
            dir: false,
            searchTerm: '',
            ///Charts
            weighinsData:{
                labels:[],
                datasets: [
                    { 
                        label:'Evolución de peso',
                        backgroundColor:'#5e8f238a',
                        data:[]
                    }
                ]
            },
            EconomicChartData:{
                //labels:['Ingresos', 'Gastos'],
                datasets: [
                    {   label:'Ingresos',
                        backgroundColor: ['#5e8f238a'],
                        data:[0]
                    },
                    {   label:'Gastos',
                        backgroundColor: ['#ff0000a1',],
                        data:[0]
                    }
                ]
            },
            BarChartOptions:{
                responsive: false,
                maintainAspectRatio: false,
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        }
                    }],
                },
            },
            chartLineOptions:{
                responsive: false,
                maintainAspectRatio: false,
                backgroundColor: false,
                hover: {
                mode: 'label',
                },
                layout: {
                padding: {
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right:20
                },
                },
                
                legend: {
                position: 'top',
                align: 'start',
                labels: {
                    usePointStyle: true,
                    padding: 25,
                    boxWidth: 9,
                },
                },
            },
            chartPieOptions:{
                responsive: false,
                maintainAspectRatio: false,
            },
            columns: [
                {
                label:  'CODIGO',
                field:  'number',
                type:   'string'
                },  
                {
                label:  'ANIMAL',
                field:  'name',
                type:   'string'
                },
                {
                label:  'SEXO',
                field:  'sex',
                type:   'boolean'
                },
                {
                label:  '+ PESO',
                field:  'weight',
                type:   'number'
                },

            ],
            rows: [],
        }
    },
    computed: {
        statusVariant() {
        const statusColor = {
            /* eslint-disable key-spacing */
            Current: 'light-primary',
            Professional: 'light-success',
            Rejected: 'light-danger',
            Resigned: 'light-warning',
            Applied: 'light-info',
            /* eslint-enable key-spacing */
        }

        return status => statusColor[status]
        },
        direction() {
        if (store.state.appConfig.isRTL) {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.dir = true
            return this.dir
        }
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = false
        return this.dir
        },
    },
    methods:{
        navigateTo(routeName){
            this.$router.push({name:routeName});
        },
        async fetchAnimalWheihins(config){
            if(this.online){
                let id= localStorage.getItem('currentFarm');
                fetch(this.$apiUrl+"list/animals?recperpage=all&state=1&farm_id="+id, config)
                .then(response => response.json())
                .then(result => {
                    console.log(result.animals);
                    this.rows = result.animals.map(item => {return {id:item.id,number:item.number,name:item.name,sex:item.sex,weight:this.formatPrice(item.dayli_weight*-1),}});
                    localStorage.setItem('animalsTemp',JSON.stringify(this.rows))
                    console.log(this.rows);
                })
            }
        },
        async fetchIncomes(config, dateReg){
            let farmId= localStorage.getItem('currentFarm');
            fetch(this.$apiUrl+"list/economic_records?farm_id="+farmId+"&type=1", config)
            .then(response => response.json())
            .then(result => {
                console.log(result.economic_records);
                this.incomes =result.economic_records.filter(function(item){
                let itemRegDate= new Date(item.date);
                return itemRegDate>= dateReg;
            }).map(
                item =>parseFloat(item.total)
            );
            
            if(this.incomes.length===0){
                this.incomes=0;
            }else{
                this.incomes= this.incomes.reduce(
                    (acc,amount )=>acc+amount
                );
            }
                //this.income_num =this.incomes;
                this.fetchExpenses(config, dateReg);
            })
        },

        async fetchExpenses(config,dateReg){
            let farmId= localStorage.getItem('currentFarm');
            fetch(this.$apiUrl+"list/economic_records?farm_id="+farmId+"&type=2", config)
            .then(response => response.json())
            .then(result => {
                console.log(result.economic_records);
                this.expenses =
                result.economic_records.filter(function(item){
                let itemRegDate= new Date(item.date);
                return itemRegDate>= dateReg;
            }).map(
                item =>parseFloat(item.total)
            );
            if (this.expenses.length===0){
                this.expenses=0;
            }else{
                this.expenses=this.expenses.reduce(
                    (acc, total)=>acc+total
                );
            }
            this.expenses_num =this.expenses;
            this.calUtility();
            });

        },

        calUtility(){
            setTimeout(()=>{
                this.utility=(this.incomes-this.expenses).toLocaleString();
                this.EconomicChartData.datasets[0].data=[this.incomes];
                this.EconomicChartData.datasets[1].data=[this.expenses];
                console.log(this.EconomicChartData);
                console.log(this.utility);
                this.showPieChart=true;
            },2000)
        },
        onConnectionChange(val){
            this.online=val;
            console.log(val);
        },
        formatPrice(value) {
            let val = (value/1).toFixed(2).replace(',', '.')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },  
    },
    created() {
        const token = localStorage.getItem("accessToken");
        const config = {headers: {"X-Authorization": `Bearer ${token}`}};
        this.online=navigator.onLine;
        let now = new Date()
        let dateReg= new Date(now.getFullYear(), now.getMonth(), 1);
        this.fetchAnimalWheihins(config);
        this.fetchIncomes(config, dateReg);
    },

}
</script>

<style lang="scss">
.title {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
    color: #5E5873;
}

.buttonContent {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    letter-spacing: 0.4px;
    color: #FFFFFF;
    flex: none;
    order: 1;
    flex-grow: 0;
}

@import '@core/scss/vue/pages/page-auth.scss';
</style>
